import {Component, OnInit} from '@angular/core';
import {RoutesService} from '../../../../../data/routes/routes.service';
import { Router, RouterLink } from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ToastService} from '../../../../../shared/services/toast.service';
import {RmRoot} from '../model/RmRoot';
import {RootRoute, SettingsRoute} from '../../../../../shared/models/angular-routing';
import {
  ConfirmationDialogComponent
} from '../../../../../shared/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import {firstValueFrom} from 'rxjs';
import { CardComponent } from '../../../../../shared/components/card/card.component';
import { CardContentDirective, CardContentRawDirective } from '../../../../../shared/components/card/card-content.directive';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatDivider, MatListItem, MatNavList } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';
import { DialogCopyRouteConfigurationComponent } from '../dialog-copy-route-configuration/dialog-copy-route-configuration.component';


@Component({
  selector: 'app-route-configuration-list',
  templateUrl: './route-configuration-list.component.html',
  styleUrls: ['./route-configuration-list.component.scss', '../../../settings-common.scss'],
  imports: [
    CardComponent,
    CardContentDirective,
    MatButton,
    MatProgressSpinner,
    CardContentRawDirective,
    MatMenu,
    MatMenuContent,
    MatMenuItem,
    RouterLink,
    MatNavList,
    MatListItem,
    MatIconButton,
    MatDivider,
    MatMenuTrigger,
    MatIcon,
  ],
})
export class RouteConfigurationListComponent implements OnInit {

  root: RmRoot;
  isLoading = true;
  breadcrumbs = '';

  protected readonly RootRoute = RootRoute;
  protected readonly SettingsRoute = SettingsRoute;

  constructor(
    public dialog: MatDialog,
    private routesService: RoutesService,
    private router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.root = RmRoot.fromRouteConfigurations([]);

    this.loadData();
  }

  private loadData() {
    this.routesService
      .getRouteConfigurations()
      .then(routeConfigsResponse => {
        this.root = RmRoot.fromRouteConfigurations(routeConfigsResponse.data);
        this.isLoading = false;
      })
      .catch(error => {
        const msg = 'Error while loading route configurations';
        this.toastService.long(msg);
        console.error(`${msg} :: ${error}`);
        this.isLoading = false;
      });
  }

  addRouteConfiguration(): void {
    this.router.navigate([`/${RootRoute.SETTINGS}`, SettingsRoute.MANAGE_ROUTES, 'new']).then();
  }

  removeConfiguration(configurationId: string, configurationName: string) {
    const ref = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Delete Confirmation',
        text: `Are you sure you want to delete Route Configuration '${configurationName}'?`,
      },
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.routesService.deleteRouteConfiguration(Number(configurationId)).then(() => {
          this.toastService.long('Route Configuration has been removed');
          this.loadData();
        }).catch(error => {
          this.toastService.long('Route Configuration removal failed!');
        });
      }
    });
  }

  copyConfiguration(configurationId: string, configurationName: string) {
    const ref = this.dialog.open(DialogCopyRouteConfigurationComponent, {
      width: '480px',
      data: `Copy of ${configurationName}`,
    });

    firstValueFrom(ref.afterClosed()).then(result => {
      if (result) {
        this.routesService.copyRouteConfiguration(Number(configurationId), result).then(() => {
          this.toastService.long('Route Configuration has been copied');
          this.loadData();
        }).catch(error => {
          this.toastService.long('Route Configuration cloning failed!');
        });
      }
    });
  }
}
